import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import logo from '../assets/icons/hem-logo.png';
import "../assets/css/header.css";
import { AppConstant } from "../constant/AppConstant";

const Header = ({
    heroSectionRef,
    aboutUsRef,
    contactDetailsRef,
    faqRef
}: {
    heroSectionRef: React.RefObject<HTMLElement | null>;
    aboutUsRef: React.RefObject<HTMLElement | null>;
    contactDetailsRef: React.RefObject<HTMLElement | null>;
    faqRef: React.RefObject<HTMLElement | null>;
}) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();
    const isHome = location.pathname === "/";

    const toggleMenu = () => setMenuOpen(!menuOpen);

    const onMenuItemClick = (e: React.MouseEvent, selectedSectionRef: React.RefObject<HTMLElement | null>) => {
        e.preventDefault();
        scrollToSection(selectedSectionRef);
        setMenuOpen(false);
    };

    const scrollToSection = (sectionRef: React.RefObject<HTMLElement | null>) => {
        sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <header className={`header ${isHome ? "transparent" : ""}`} ref={heroSectionRef}>
            <div className="container">
                <div className="header-content">
                    <a href="#" onClick={(e) => { e.preventDefault(); scrollToSection(heroSectionRef); }} className="logo">
                        <img src={logo} alt="Logo" />
                    </a>

                    <nav className={`nav ${menuOpen ? "open" : ""}`}>
                        <a href="#" className="nav-link" onClick={(e) => onMenuItemClick(e, heroSectionRef)}>Home</a>
                        <a href="#" className="nav-link" onClick={(e) => onMenuItemClick(e, aboutUsRef)}>About Us</a>
                        <a href="#" className="nav-link" onClick={(e) => onMenuItemClick(e, contactDetailsRef)}>Contact Us</a>
                        <a href="#" className="nav-link" onClick={(e) => onMenuItemClick(e, faqRef)}>FAQ</a>
                    </nav>

                    <div className="social-icons">
                        {/* <a href={AppConstant.FACEBOOK_LINK} target="_blank" rel="noopener noreferrer" className="icon">
                            <i className="fab fa-facebook-f" ></i>
                        </a> */}
                        <a href={AppConstant.INSTA_LINK} target="_blank" rel="noopener noreferrer" className="icon">
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a href={AppConstant.CALL_PHONE_NUMBER} className="contact-text icon" >
                            <i className="fa-solid fa-phone"></i>
                        </a>
                        <span className="social-text">{AppConstant.CONTACT_PHONE_NUMBER}</span>
                    </div>

                    <button className={`menu-toggle ${menuOpen ? "open" : ""}`} onClick={toggleMenu}>
                        <span className="bar top"></span>
                        <span className="bar middle"></span>
                        <span className="bar bottom"></span>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
